import { useEffect, useState } from "react";
import { useDataFetch } from "./core/hooks/useDataFetch";
import { Config } from "./config/config";
import { AppActions } from "./core/store/reducers";
import { useConfig } from "./core/store/selectors/useConfig";
import { useAppState } from "./core/store/contextProvider";
import useCookie from "./core/hooks/useCookie";
import { useLogout } from "./core/hooks/useLogout";

function AppInit({ children }) {
  const { getToken, getTradingMode } = useCookie();
  const { session, updateStore } = useAppState();
  const { updateLoginSuccess } = useConfig();
  const { callAPI } = useDataFetch();
  const { logout } = useLogout();
  const [isAuthenticated, setAuth] = useState(false);

  useEffect(() => {
    const validateSession = async () => {
      if (session?.isValidSession) {
        const savedMode = getTradingMode();
        updateStore({
          type: AppActions.updateTheme,
          payload: { mode: savedMode, isVirtual: savedMode === "PT" },
        });
        setAuth(true);
        return;
      }

      const iToken = getToken();
      if (!iToken) {
        await logout(); // clears everything (incl. any server session) before login
        return;
      }

      // Use single configured API base URL (no override from cookie)
      const profileData = await callAPI(
        Config.ITradeAPI.validateSession,
        {},
        {},
        "POST",
        false,
        null
      );

      if (profileData.status && profileData.data?.isValidSession) {
        const savedMode = getTradingMode();
        updateStore({
          type: AppActions.updateTheme,
          payload: { mode: savedMode, isVirtual: savedMode === "PT" },
        });
        setAuth(true);
        await updateLoginSuccess(false, profileData.data.userDetails, null);
      } else {
        await logout(); // clears everything (incl. any server session) before login
      }
    };

    validateSession();
  }, []);

  return isAuthenticated ? children : null;
}

export default AppInit;
